<section class="results-section">
    <h2 class="results-title">RESULTS</h2>
    <hr class="divider" />

    <p class="results-summary">
        @if (analysis.areAllValidFactorsIncomplete()) {
            The analysis was
            <strong
                >unable to find any responses for this task's requirements in the file(s)
                provided.</strong
            >
            Double-check to ensure you've uploaded the correct file(s) for this task. If your
            file(s) are not compatible with this scan, review them against the task instructions to
            be sure they include responses to each requirement before submitting them for
            evaluation.
        } @else if (analysis.areAllValidFactorsComplete()) {
            <div>
                Nice work! You've touched on every part of the rubric. This means you've made an
                attempt to address each key requirement.
            </div>
            <div>
                <strong>Reminder</strong>: This check doesn't judge quality—it simply shows that
                you've attempted each aspect. Review your evaluator's feedback and the rubric itself
                to ensure your work meets expectations.
            </div>
        } @else {
            Great progress! Before you officially submit, it looks like
            <strong
                >{{ analysis.getIncompleteValidFactors().length | numberToWord }} rubric aspect{{
                    analysis.getIncompleteValidFactors().length === 1 ? '' : 's'
                }}
                {{ analysis.getIncompleteValidFactors().length === 1 ? 'was' : 'were' }} not
                covered</strong
            >
            by the file(s) you uploaded.
        }
    </p>

    @if (!analysis.areAllValidFactorsIncomplete()) {
        <div class="results-cards">
            @for (item of analysis.getIncompleteValidFactors(); track item.id) {
                <app-result-card [factor]="item"></app-result-card>
            }
        </div>
    }
</section>
